import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
  Box,
  Button,
  Paper,
  Typography,
  CircularProgress,
  Alert
} from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';
import Lottie from 'lottie-react';
import animatedLogo from '../assets/logos/IMPRES-Logo-Animated-Black.json';

function Login() {
  const { signIn } = useAuth();
  const [isSigningIn, setIsSigningIn] = useState(false);
  const [error, setError] = useState(null);

  const handleSignIn = async () => {
    try {
      setIsSigningIn(true);
      setError(null);
      await signIn();
    } catch (err) {
      setError('Failed to sign in. Please try again.');
      console.error('Sign in error:', err);
      setIsSigningIn(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #32578b 0%, #5a7fad 100%)',
        p: 2
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: { xs: 3, sm: 5 },
          textAlign: 'center',
          maxWidth: 380,
          width: '100%',
          borderRadius: 2
        }}
      >
        <Box
          sx={{
            width: { xs: '160px', sm: '200px' },
            height: { xs: 96, sm: 120 },
            mx: 'auto',
            mb: 2
          }}
        >
          <Lottie
            animationData={animatedLogo}
            loop={true}
            autoplay={true}
          />
        </Box>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          QB Archive
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Sign in with your Microsoft 365 account to access
          the QB Archive
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        <Button
          variant="contained"
          size="large"
          startIcon={isSigningIn ? <CircularProgress size={20} color="inherit" /> : <LoginIcon />}
          onClick={handleSignIn}
          disabled={isSigningIn}
          fullWidth
          sx={{
            py: 1.5,
            fontSize: '1.1rem',
            textTransform: 'none',
            fontWeight: 'bold'
          }}
        >
          {isSigningIn ? 'Signing in...' : 'Sign in with Microsoft'}
        </Button>

        <Typography variant="caption" color="text.secondary" sx={{ mt: 3, display: 'block' }}>
          Use your @imprestechnology.com account
        </Typography>
      </Paper>
    </Box>
  );
}

export default Login;
